import {styled} from "@mui/material/styles";
import {Button, ButtonGroup, Grid} from "@mui/material";

export const ButtonSwitchGroup = styled(ButtonGroup)(() => ({
  display: 'flex',
  alignItems: 'center',
  background: "#fff",
  borderRadius: 8,
  marginBottom: 5,
}));

export const ButtonSwitchButton = styled(Button)(({theme}) => ({
  flexGrow: 1,
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    minWidth: '10.71em',
  }
}));

export const ButtonSwitchPadding = styled(Grid)(({theme}) => ({
  padding: 6,
  width: "100%",
  display: "flex",
  gap: 10,
  flexWrap: 'wrap',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    flexWrap: 'nowrap'
  }
}));
